import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ModelService } from './model-service'; 
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-model',
  standalone: true,
  imports: [CommonModule, FormsModule, MatIconModule],
  templateUrl: './model.html',
  styleUrls: ['./model.scss'],
})
export class Model implements OnInit {
  searchTerm: string = '';
  models: string[] = [];
  filteredModels: string[] = [];
  selectedModel: string = '';   // fixed from 'null'
  selectedMake: string = '';
  loading: boolean = true;

  constructor(private router: Router, private modelService: ModelService) {}

  ngOnInit(): void {
    this.loading = true;

    // Pick selected make from localStorage (fallback empty string)
    this.selectedMake =
      localStorage.getItem('newMake') ||
      localStorage.getItem('selectedMake') ||
      '';

    // Pick selected model if exists
    this.selectedModel = localStorage.getItem('selectedModel') || '';

    this.getModelList();
  }

  // Fetch models from stored data
getModelList() {
  const data = this.modelService.getModel();
  if (!data) {
    this.loading = false;
    return;
  }

  const res = JSON.parse(data);
  this.models = [];

  // console.log('selectedMake:', this.selectedMake);
  // console.log('all makes:', Object.keys(res.data));

  if (res.data && res.data[this.selectedMake]) {
    res.data[this.selectedMake].forEach((m: any) => {
      this.models.push(m.model || m.title);
    });
  } else {
    console.warn('No models found for make:', this.selectedMake);
  }

  this.filteredModels = this.models;
  this.loading = false;
}


  // Handle search filter
  updateFilter() {
    if (!this.searchTerm) {
      this.filteredModels = this.models;
    } else {
      this.filteredModels = this.models.filter((model: string) =>
        model.toLowerCase().includes(this.searchTerm.toLowerCase())
      );
    }
  }

  clearSearch() {
    this.searchTerm = '';
    this.filteredModels = this.models;
  }

  // Select model and save
  selectModel(model: string) {
    this.selectedModel = model;

    if (
      localStorage.getItem('selectedMake') &&
      localStorage.getItem('selectedModel') &&
      localStorage.getItem('selectedYear') &&
      localStorage.getItem('variant')
    ) {
      localStorage.setItem('newModel', model);
    } else {
      localStorage.setItem('selectedModel', model);
    }

    this.router.navigate(['year']);
  }

  goToMake() {
    this.router.navigate(['make']);
  }
  
}
